import { Checkbox, FormControlLabel } from "@material-ui/core"
import type { ReactElement } from "react"
import type { Control, ControllerRenderProps, Path } from "react-hook-form"
import { Controller } from "react-hook-form"

export interface ICheckboxControlProps<T> {
  label?: string
  name: Path<T>
  control: Control<T>
  disabled?: boolean
  className?: string
}

export function CheckboxControl<T>(props: ICheckboxControlProps<T>): ReactElement {
  const { name, label, control, disabled, className } = props

  function getValue(field: ControllerRenderProps<T, Path<T>>): boolean {
    return field.value as boolean
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          className={`checkbox-control ${className || ""}`}
          label={label}
          disabled={disabled}
          control={<Checkbox color="primary" disabled={disabled} {...field} />}
          checked={getValue(field)}
        />
      )}
    />
  )
}
